import { EHRProvider } from '@heidi/schema/ml-scribe';

/**
 * Telus CHR EHR Launch renders the markdown sectional editor for every
 * onboarded user. Unlike the Athena/AdvancedMD cohorts this is not flag-gated:
 * the integration has no production users, so there is no legacy JSON-editor
 * cohort to keep stable. A plain predicate so `useEnableBlockEditorV1` and its
 * imperative twin `isEnableBlockEditorV1` (called from the note-generation
 * stream pipeline and copy helpers) share one definition.
 */
export const isTelusMarkdownSectional = (ehrProvider?: EHRProvider | null): boolean =>
  ehrProvider === EHRProvider.Telus_CHR_EHR_Launch;
